import React from 'react';
import {Button, Dialog} from "@blueprintjs/core";
import {DatePicker} from 'components/tt-forms/common';

class ConfirmDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: this.props.loading,
      thoiHan: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      loading: nextProps.loading
    })
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.state[name] = e._d;
    } else {
      this.state[name] = e;
    }
    this.setState({...this.state});
    this.props.onChangeDate(this.state[name]);
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  handleSuccess() {
    if (this.props.withTime) {
      if (this.validateSubmitForm()) {
        this.props.onSuccess();
      }
    } else {
      this.props.onSuccess();
    }
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.open}
        onClose={this.props.onClose}
        title="Xác nhận"
        className="reception-dialog delete-dialog wrap-block"
        >
        <div className="pt-dialog-body">
          <p className="reception-dialog-text" dangerouslySetInnerHTML={{ __html: this.props.title }}></p>
          {
            this.props.withTime ?
              <DatePicker className="dpk-inline mb0-18" require label='Thời hạn báo cáo' bindValidator={this} channel="formTaoDon" value={this.state.thoiHan} onChange={this.handleChangeDate.bind(this, 'thoiHan')} />
            :''
          }
        </div>
        {
          this.props.withTime ?
            <div className='row pl15 pr15'>
              <span className='line-border mb20'></span>
            </div>
          :''
        }
        <div className="pt-dialog-footer">
          <div className="pt-dialog-footer-actions reception-delete-confirm">
            <Button
              onClick={this.props.onClose}
              text="Không"
              className="btn-default"
            />
            <Button
              onClick={this.handleSuccess.bind(this)}
              text="Đồng ý"
              className={`btn-green ${this.props.loading === true ? 'btn-loading-inline' : ''}`}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

ConfirmDialog.defaultProps = {
  title: 'Dữ liệu này đã tồn tại trong hệ thống. Bạn muốn sử dụng dữ liệu có sẵn?',
  loading: false,
  withTime: false,
  validators: {}
}

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/ConfirmDialog.jsx